import { getJson } from '../../../../shared/api/httpClient';
import config from '../../../../configs/config';

export function resetPassword({ idUser, newPassword, urlCode }) {
  return getJson('UserResetPwdMarival', {
    Type: 2,
    Id_User: idUser,
    NewPassword: newPassword,
    ConfirmEmailUrlCode: urlCode,
    Brand: config.emailBrand
  }, {
    errorMessage: 'Restore password request failed'
  });
}
